define('app/sf/service/speed/sf-service-speed-filter',[],function () {
	"use strict";
	var split = "$1 $2",
		splitSlash = "$1/$2",
		parenthesis = "($1)";
	return sfServiceSpeed;
	function sfServiceSpeed(speedEnum) {
		return (speedEnum + "")
			.replace(/(Up)(to)(?=[^a-z])/g, split)
			.replace(/([^0-9])([0-9])/g, split)
			.replace(/([a-z])([A-Z])/g, split)
			.replace(/(Annex [A-Za-z]+)/g, parenthesis)
			.replace(/([0-9]+(?:Mbps|kbps|Gbps|Pbps|bps))\s+([0-9]+(?:Mbps|kbps|Gbps|Pbps|bps))/, splitSlash);
	}
});
